// extracted by mini-css-extract-plugin
export default {"text":"ClientDetailsCommentModal_text__ZolsS","deleteModalContent":"ClientDetailsCommentModal_deleteModalContent__Haysw"};